import React from "react";

// Action Button Styles
export const actionButtonStyle: React.CSSProperties = {
  width: "calc(260px * var(--zoom))",
  height: "calc(175px * var(--zoom))",
  padding: "calc(2px * var(--zoom))",
  borderRadius: "calc(10px * var(--zoom))",
  backgroundColor: "#0a1971",
  boxSizing: "border-box",
  textAlign: "center",
  lineHeight: "normal",
  fontSize: "calc(18px * var(--zoom))",
  fontWeight: "700",
  color: "#fff",
};
export const actionIconStyle: React.CSSProperties = {
  width: "calc(50px * var(--zoom))",
  height: "calc(50px * var(--zoom))",
  boxSizing: "border-box",
};
export const actionIconStyle2: React.CSSProperties = {
  width: "calc(30px * var(--zoom))",
  height: "calc(30px * var(--zoom))",
  marginRight: "calc(-12px * var(--zoom))",
  marginTop: "calc(-175px * var(--zoom))",
  position: "relative",
  zIndex: 1,
};

export const actionContainer: React.CSSProperties = {
  marginTop: "10vh",
  marginLeft: "calc(40px * var(--zoom))",
  marginRight: "auto",
  width: "60vw",
};

export const actionMarkupText: React.CSSProperties = {
  color: "rgba(33, 37, 41, 0.75)",
  margin: "calc(8px * var(--zoom)) 0 calc(16px * var(--zoom))",
  fontSize: "calc(20px * var(--zoom))",
};

export const actionButtonWrapper: React.CSSProperties = {
  width: "100%",
};

export const actionButtonTitle: React.CSSProperties = {
  fontSize: "calc(20px * var(--zoom))",
  paddingTop: "calc(15px * var(--zoom))",
};

export const actionButtonImage: React.CSSProperties = {
  paddingTop: "calc(10px * var(--zoom))",
};

// Button Styles
export const commonButtonStyles: React.CSSProperties = {
  width: "calc(250px * var(--zoom))",
  height: "calc(57px * var(--zoom))",
  padding: "calc(10px * var(--zoom))",
  borderRadius: "calc(8px * var(--zoom))",
  boxSizing: "border-box",
  textAlign: "center",
  lineHeight: "normal",
  fontSize: "calc(20px * var(--zoom))",
  display: "inline-block",
  borderWidth: "calc(1px * var(--zoom))",
};

export const secondaryButtonStyle: React.CSSProperties = {
  ...commonButtonStyles,
  backgroundColor: "#868686",
  borderColor: "#868686",
  color: "#ffffff",
};

export const primaryButtonStyle: React.CSSProperties = {
  ...commonButtonStyles,
  backgroundColor: "#fffefe",
  borderColor: "#868686",
  color: "#5e5e5e",
};

// Clock Styles
export const clockIconStyle: React.CSSProperties = {
  margin:
    "calc(6px * var(--zoom)) calc(6px * var(--zoom)) 0 calc(2px * var(--zoom))",
  color: "#fff",
  float: "right",
  marginBottom: "0",
  lineHeight: "1.3rem",
};

// Error Styles
export const errorIconStyle: React.CSSProperties = {
  width: "calc(44px * var(--zoom))",
  height: "calc(44px * var(--zoom))",
};

export const errorContainer: React.CSSProperties = {
  padding:
    "calc(15px * var(--zoom)) calc(2px * var(--zoom)) calc(2px * var(--zoom)) calc(18px * var(--zoom))",
  borderRadius: "calc(6px * var(--zoom))",
  boxSizing: "border-box",
  display: "block",
  textAlign: "left",
  lineHeight: "normal",
  fontSize: "calc(14px * var(--zoom))",
  width: "100%",
};

export const errorHeader: React.CSSProperties = {
  paddingBottom: "0",
  marginBottom: "0",
};
export const errorBody: React.CSSProperties = {
  width: "50%",
  borderRadius: "calc(6px * var(--zoom))",
  backgroundColor: "#ffe8e8",
  boxSizing: "border-box",
  color: "#333333",
  textAlign: "left",
  lineHeight: "calc(30px * var(--zoom))",
  padding: "calc(25px * var(--zoom))",
  marginTop: "calc(25px * var(--zoom))",
  marginBottom: "calc(50px * var(--zoom))",
};

// Footer Styles
export const footerContainer: React.CSSProperties = {
  position: "fixed",
  width: "100%",
  bottom: "0px",
};

export const footerPrimaryBackground: React.CSSProperties = {
  backgroundImage:
    "linear-gradient(-90deg, #ffffff 0.14641288433382138%, #67b2cf 50.07320644216691%, #ffffff 100%)",
};

export const footerBackground: React.CSSProperties = {
  height: "calc(60px * var(--zoom))",
  padding: "calc(2px * var(--zoom))",
  backgroundImage:
    "linear-gradient(-90deg, #ffffff 0.14641288433382138%, #f0cc6f 50.07320644216691%, #ffffff 100%)",
  boxSizing: "border-box",
};

// Reconnect Modal Styles
export const spinnerIcon: React.CSSProperties = {
  height: "calc(50px * var(--zoom))",
  width: "calc(50px * var(--zoom))",
};

export const reconnectTitle: React.CSSProperties = {
  textAlign: "left",
};

export const reconnectTitleBold: React.CSSProperties = {
  textAlign: "left",
  fontWeight: 700,
};

export const reconnectContainer: React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const dialogPopUp: React.CSSProperties = {};

// Title Styles

export const titleStyled: React.CSSProperties = {
  backgroundColor: "rgba(4, 78, 152, 0)",
  boxSizing: "border-box",
  textAlign: "center",
  fontSize: "calc(30px * var(--zoom))",
  color: "#044e98",
};

export const secondaryTitleStyled: React.CSSProperties = {
  ...titleStyled,
  fontSize: "calc(33px * var(--zoom))",
  color: "#666666",
};

export const errorTitleStyled: React.CSSProperties = {
  ...titleStyled,
  fontSize: "calc(33px * var(--zoom))",
  color: "#66000c",
  padding: "calc(20px * var(--zoom))",
};

export const subTitleStyled: React.CSSProperties = {
  ...titleStyled,
  fontSize: "calc(18px * var(--zoom))",
  color: "#666666",
};

export const textStyled: React.CSSProperties = {
  backgroundColor: "rgba(4, 78, 152, 0)",
  boxSizing: "border-box",
  textAlign: "center",
  fontSize: "calc(16px * var(--zoom))",
  color: "#333333",
  paddingBottom: "calc(24px * var(--zoom))",
};

// Warning Styles
export const warningContainer: React.CSSProperties = {
  padding:
    "calc(15px * var(--zoom)) calc(2px * var(--zoom)) calc(2px * var(--zoom)) calc(18px * var(--zoom))",
  borderRadius: "calc(6px * var(--zoom))",
  boxSizing: "border-box",
  display: "block",
  textAlign: "left",
  lineHeight: "normal",
  fontSize: "calc(14px * var(--zoom))",
  width: "100%",
};

export const warningErrorBody: React.CSSProperties = {
  width: "fit-content",
  borderRadius: "calc(6px * var(--zoom))",
  boxSizing: "border-box",
  color: "#333333",
  textAlign: "center",
  lineHeight: "calc(50px * var(--zoom))",
  padding: "calc(25px * var(--zoom))",
  marginTop: "calc(25px * var(--zoom))",
  marginBottom: "calc(50px * var(--zoom))",
  marginLeft: "auto",
  marginRight: "auto",
  fontSize: "calc(18px * var(--zoom))",
};

export const warningErrorHeader: React.CSSProperties = {
  paddingBottom: "0",
  marginBottom: "0",
  justifyContent: "center",
};

export const warningErrorCodeStyle: React.CSSProperties = {
  color: " #943B3B",
  marginBottom: "calc(2px * var(--zoom))",
  fontWeight: "700",
  fontSize: "calc(24px * var(--zoom))",
};

// Wait Styles
export const waitContainer: React.CSSProperties = {
  backgroundColor: "rgba(255, 255, 255, 0)",
  boxSizing: "border-box",
  padding:
    "calc(2px * var(--zoom)) calc(2px * var(--zoom)) calc(2px * var(--zoom)) calc(2px * var(--zoom))",
};

// Version Styles
export const versionContainer: React.CSSProperties = {
  margin: "calc(2px * var(--zoom))",
  background: "inherit",
  boxSizing: "border-box",
  borderWidth: "calc(1px * var(--zoom))",
  borderStyle: "solid",
  borderRadius: "calc(5px * var(--zoom))",
  boxShadow: "none",
  fontStyle: "normal",
  maxWidth: "fit-content",
  display: "inline-block",
  float: "right",
  padding: "calc(3.2px * var(--zoom)) calc(4.8px * var(--zoom))",
};

export const versionTitle: React.CSSProperties = {
  fontSize: "calc(13px * var(--zoom))",
  verticalAlign: "top",
  marginRight: "calc(4.80px * var(--zoom))",
};

export const vesionTag = {
  fontSize: "calc(28px * var(--zoom))",
  marginLeft: "0",
  lineHeight: "1.5",
};

// SubHeader Styles
export const subHeaderContainer: React.CSSProperties = {
  width: "100%",
  position: "relative",
  display: "inline-block",
};

export const subeHeaderLogo: React.CSSProperties = {
  userSelect: "none",
  padding:
    "calc(15px * var(--zoom)) calc(20px * var(--zoom)) calc(20px * var(--zoom))",
  float: "left",
  display: "inline-block",
};

export const subHeaderInfoContainer: React.CSSProperties = {
  float: "right",
  padding:
    "calc(15px * var(--zoom)) calc(20px * var(--zoom)) calc(20px * var(--zoom))",
  textAlign: "right",
};

export const subHeaderDeviceInfoContainer: React.CSSProperties = {
  fontSize: "calc(26px * var(--zoom))",
  fontWeight: "bold",
  fontStyle: "normal",
  textAlign: "right",
  color: "#414141",
  lineHeight: "1.5",
};

export const subHeaderDeviceId: React.CSSProperties = {
  fontWeight: "500",
  marginRight: "calc(2px * var(--zoom))",
};

export const subHeaderDeviceIdBold: React.CSSProperties = {
  fontWeight: "800",
};

export const subHeaderDeviceType: React.CSSProperties = {
  fontWeight: "800",
  marginRight: "calc(2px * var(--zoom))",
};

// Frame Styles
export const frameStyled: React.CSSProperties = {
  padding: "calc(2px * var(--zoom))",
  boxSizing: "border-box",
};

export const frameStyledTop: React.CSSProperties = {
  ...frameStyled,
  backgroundColor: "#004c97",
  height: "auto",
  display: "inline-block",
  width: "100%",
  padding: "calc(4.8px * var(--zoom)) calc(2px * var(--zoom)) 0",
};

export const frameStyledBottom: React.CSSProperties = {
  ...frameStyled,
  height: "calc(20px * var(--zoom))",
};

export const frameStyleBody: React.CSSProperties = {
  ...frameStyled,
  margin: "auto",
  textAlign: "center",
  top: "0",
  position: "relative",
  padding: "0 calc(20px * var(--zoom)) calc(20px * var(--zoom))",
  marginTop: "0",
};

export const customProgressBar: React.CSSProperties = {
  width: "100%",
  backgroundColor: "#e9ecef",
  borderRadius: "calc(5px * var(--zoom))",
  overflow: "hidden",
};

export const customProgressBarFill: React.CSSProperties = {
  height: "calc(45px * var(--zoom))",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "width 0.5s ease-in-out",
};

export const customizedProgressBarLabel: React.CSSProperties = {
  fontSize: "calc(14px * var(--zoom))",
  color: "#fff",
};

export const iconStyle: React.CSSProperties = {
  width: "calc(32px * var(--zoom))",
  height: "calc(32px * var(--zoom))",
  margin:
    "calc(5px * var(--zoom)) calc(15px * var(--zoom)) calc(2px * var(--zoom)) calc(2px * var(--zoom))",
  color: "#fff",
  float: "right",
  marginTop: "0",
  marginBottom: "0",
};

export const wifiIconStyle: React.CSSProperties = {
  width: "calc(32px * var(--zoom))",
  height: "calc(32px * var(--zoom))",
  margin:
    "calc(5px * var(--zoom)) calc(15px * var(--zoom)) calc(2px * var(--zoom)) calc(2px * var(--zoom))",
  color: "#fff",
  float: "right",
  marginTop: "0",
  marginBottom: "0",
};

export const batteryIconStyle: React.CSSProperties = {
  width: "calc(32px * var(--zoom))",
  height: "calc(32px * var(--zoom))",
  color: "#fff",
  float: "right",
  marginTop: "0",
  marginBottom: "0",
};

export const actionArrowIconStyle: React.CSSProperties = {
  width: " 2em",
  height: "2em",
  margin:
    "calc(5px * var(--zoom)) calc(15px * var(--zoom)) calc(2px * var(--zoom)) calc(2px * var(--zoom))",
  color: "white",
  float: "right",
  cursor: "pointer",
  marginTop: "0",
  marginBottom: "0",
};

export const exitAppIconStyle: React.CSSProperties = {
  background: "transparent",
  border: "none",
  padding: "0",
};

// Header Styles
export const LanguageSwitchContainer = {
  width: "calc(560px * var(--zoom))",
  fontSize: "calc(16px * var(--zoom))",
  textAlign: "right",
  float: "left",
};

export const homeButtonV2 = {
  display: "inline-block",
  backgroundColor: "#171c66",
  color: "#ffffff",
  fontSize: "calc(16px * var(--zoom))",
  padding:
    "calc(9px * var(--zoom)) calc(12px * var(--zoom)) calc(08px * var(--zoom))",
};

export const homeButtonV2Disabled = {
  ...homeButtonV2,
  opacity: "0.38",
};

export const LanguageSwitchContainerV2 = {
  width: "calc(85px * var(--zoom))",
  fontSize: "calc(16px * var(--zoom))",
  textAlign: "center",
  borderWidth: "0 calc(1px * var(--zoom))",
  borderColor: "#87a6ca",
  borderStyle: "solid",
  display: "inline-block",
};

export const connectionInfoV2 = {
  display: "inline-block",
  backgroundColor: "#e7ffe1",
  borderRadius: "calc(20px * var(--zoom))",
  borderColor: "#00cd0b",
  padding: "0 calc(10px * var(--zoom)) 0 calc(20px * var(--zoom))",
  color: "#000",
  margin: "calc(15px * var(--zoom)) calc(10px * var(--zoom))",
};

export const vesionTagV2 = {
  fontSize: "calc(22px * var(--zoom))",
  marginLeft: "0",
  lineHeight: "1.5",
};

export const versionContainerV2: React.CSSProperties = {
  margin: "0 calc(10px * var(--zoom)) 0 0",
  background: "inherit",
  boxSizing: "border-box",
  boxShadow: "none",
  fontStyle: "normal",
  maxWidth: "fit-content",
  display: "inline-block",
};

export const versionTitleV2: React.CSSProperties = {
  fontSize: "calc(16px * var(--zoom))",
  verticalAlign: "super",
  marginRight: "calc(10px * var(--zoom))",
};

export const iconsContainerV2: React.CSSProperties = {
  display: "inline-block",
  verticalAlign: "bottom",
};

export const iconsAltPosV2 = {
  verticalAlign: "bottom",
};

export const homeV2 = {
  display: "inline-block",
};

export const langToggle: React.CSSProperties = {
  paddingTop: "calc(7px * var(--zoom))",
};

export const headerLinkV2: React.CSSProperties = {
  color: "#fff",
  fontSize: "calc(16px * var(--zoom))",
  display: "inline-block",
  background: "transparent",
  padding: "calc(7px* var(--zoom)) calc(12px* var(--zoom))",
  fontWeight: "normal",
  border: "none",
  width: `calc(87px * var(--zoom))`,
};

export const headerLinkButtonV2: React.CSSProperties = {
  ...headerLinkV2,
};

export const exitAppIconStyleV2: React.CSSProperties = {
  background: "transparent",
  border: "none",
  display: "block",
  fontSize: "calc(16px * var(--zoom))",
  padding: "calc(09px * var(--zoom)) calc(20px * var(--zoom))",
};

export const exitAppIconStyleV2Disabled: React.CSSProperties = {
  background: "transparent",
  border: "none",
  display: "block",
  fontSize: "calc(16px * var(--zoom))",
  padding: "calc(09px * var(--zoom)) calc(20px * var(--zoom))",
  opacity: "0.38",
};

export const exitButtonWrapperV2: React.CSSProperties = {
  display: "inline-block",
  float: "right",
  color: "#fff",
  verticalAlign: "sub",
  borderLeft: "calc(1px * var(--zoom)) solid #87a6ca",
};

export const exitIconV2: React.CSSProperties = {
  paddingTop: "calc(5px * var(--zoom))",
};

export const headerLink: React.CSSProperties = {
  color: "#fff",
  fontSize: "calc(16px * var(--zoom))",
  display: "inline-block",
  background: "transparent",
  border: "none",
  padding: "calc(6px* var(--zoom)) calc(12px* var(--zoom))",
};

export const headerLinkButton: React.CSSProperties = {
  ...headerLink,
  textDecoration: "underline",
};

export const headerContainer: React.CSSProperties = {
  width: "100%",
  top: "0px",
  position: "relative",
  fontSize: "calc(16px * var(--zoom))",
  fontFamily: 'OpenSans-Regular, "Open Sans", sans-serif',
};

export const endSession: React.CSSProperties = {
  float: "left",
  color: "#fff",
  margin: "calc(5.8px * var(--zoom)) 0px 0px calc(16px * var(--zoom))",
  borderRight: "calc(0.5px * var(--zoom)) solid #fff",
  paddingRight: "0.7rem",
  marginRight: "0",
  fontSize: "calc(16px * var(--zoom))",
};

export const modalCloseArrowContainer: React.CSSProperties = {
  position: "relative",
};

export const modalCloseArrowButton: React.CSSProperties = {
  border: "none",
  padding: "0",
  float: "right",
};

export const closeArrow: React.CSSProperties = {
  width: "calc(16px * var(--zoom))",
  height: "calc(16px * var(--zoom))",
  position: "absolute",
  right: "calc(13px * var(--zoom))",
  top: "calc(5px * var(--zoom))",
  zIndex: "100",
  cursor: "pointer",
};

export const modalButtonContainer: React.CSSProperties = {
  justifyContent: "flex-start",
  border: "none",
};

export const onAsessmentButton: React.CSSProperties = {
  backgroundColor: "#0a1971",
  borderColor: "#0a1971",
  borderRadius: "calc(4px * var(--zoom))",
  fontSize: "calc(16px * var(--zoom))",
  marginRight: "calc(10px * var(--zoom))",
};

export const exitAssessmentButton: React.CSSProperties = {
  backgroundColor: "#696969",
  borderColor: "#696969",
  color: "#fff",
  borderRadius: "calc(4px * var(--zoom))",
  fontSize: "calc(16px * var(--zoom))",
};

export const assessmentTitleText: React.CSSProperties = {
  fontSize: "calc(25px * var(--zoom))",
  display: "inline-block",
  float: "left",
};

export const assessmentBodyText: React.CSSProperties = {
  display: "inline-block",
  padding: "calc(20px * var(--zoom)) 0",
};

export const connectionGroupWrapper: React.CSSProperties = {
  textAlign: "right",
  display: "block",
};

export const connectionGroupWrapperV2: React.CSSProperties = {
  display: "inline-block",
  float: "right",
  textAlign: "center",
};

export const connectionType: React.CSSProperties = {
  display: "inline-block",
  marginRight: "calc(10px * var(--zoom))",
  verticalAlign: "top",
};

export const clockAndIcons: React.CSSProperties = {
  display: "inline-block",
};

export const connectionContainer = {
  color: "#fff",
  marginTop: "calc(8px * var(--zoom))",
  lineHeight: "1.1",
};

export const warningContainerBox: React.CSSProperties = {
  padding: "0",
  width: "calc(400px * var(--zoom))",
  border: "1px solid #f3b9bd",
  position: 'absolute',
  left: '0',
  right: '0',
  margin: '0 auto',
  top: 'calc(34px * var(--zoom))',
  boxShadow: '1px 2px 5px #868686'
}

export const warningTitleAreaStyle: React.CSSProperties = {
  backgroundColor: "rgb(249 228 230)",
  color: "#333",
  fontWeight: "600",
  textAlign: "left",
  padding: "calc(10px * var(--zoom))",
  display: "table",
  width: "100%",
  borderBottom: "calc(1px * var(--zoom)) solid rgb(243 171 176)",
};

export const warningCloseBtn: React.CSSProperties = {
  backgroundColor: "transparent",
  border: "none",
  float: "right",
};

export const warningCloseImg: React.CSSProperties = {
  width: "calc(16px * var(--zoom))",
  height: "calc(16px * var(--zoom))",
};

export const warningTitleText: React.CSSProperties = {
  float: "left",
  color: "#8b0000",
  fontWeight: "700",
  fontSize: "calc(20px * var(--zoom))",
  display: "inline-block",
};

export const warningBodyAreaText: React.CSSProperties = {
  fontSize: "calc(18px * var(--zoom))",
  backgroundColor: "rgb(255, 222, 222)",
  textAlign: "left",
  padding: "calc(10px * var(--zoom))",
};

export const caretRightFill: React.CSSProperties = {
  borderTop: "calc(6px * var(--zoom)) solid transparent",
  borderBottom: "calc(6px * var(--zoom)) solid transparent",
  borderLeft: "calc(6px * var(--zoom)) solid #fff",
  display: "inline-block",
  padding: "0px calc(3px * var(--zoom))",
};

// Updater Styles

export const updaterCommonContainer: React.CSSProperties = {
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  alignSelf: "stretch",
};

export const updaterSecondaryTitle: React.CSSProperties = {
  paddingBottom: "calc(60px * var(--zoom))",
};

export const updaterSubTitle: React.CSSProperties = {
  paddingBottom: "calc(60px * var(--zoom))",
};


// ScreenDialog Styles
export const screenDialogContainer: React.CSSProperties = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: 'rgba(2, 2, 2, 0.8)',
  zIndex: 800,
};

export const screenDialogBoxWrapper: React.CSSProperties = {
  backgroundColor: '#fff',
  width: "calc(497px * var(--zoom))",
  boxShadow: '1px 2px 5px #868686',
  position: 'absolute',
  left: '0',
  right: '0',
  margin: '0 auto',
  top: '50%',
  transform: 'translateY(-50%)',
  padding: 'calc(38px * var(--zoom))',
  borderRadius: 'calc(8px * var(--zoom))',
}

export const screenDialogTitleArea: React.CSSProperties = {
  display: 'inline-block',
  paddingBottom: 'calc(20px * var(--zoom))',
}

export const screenDialogTitleText: React.CSSProperties = {
  color: '#333333',
  fontWeight: '600',
  fontSize: 'calc(20px * var(--zoom))',
}

export const screenDialogBodyArea: React.CSSProperties = {
  display: 'block',
  color: '#333333',
  paddingBottom: 'calc(40px * var(--zoom))',
  fontSize: 'calc(20px * var(--zoom))',
}

export const screenDialogButtonWrapper: React.CSSProperties = {
  
}

export const screenDialogButtons: React.CSSProperties = {
  borderColor: 'transparent',
  padding: 'calc(16px * var(--zoom))',
  borderRadius: 'calc(4px * var(--zoom))',
  color: '#fff',
  fontSize: 'calc(18px * var(--zoom))',
  width: 'calc(160px * var(--zoom))',
  justifyContent: 'center',
}
export const screenDialogConfirm: React.CSSProperties = {
  ...screenDialogButtons,
  backgroundColor: '#004c97',
  marginRight: 'calc(10px * var(--zoom))',
}

export const screenDialogCancel: React.CSSProperties = {
  ...screenDialogButtons,
  backgroundColor: '#696969',
}